module.exports = __webpack_public_path__ + "img/Danmark tester synet.1bada6d1.svg";